import { Routes, useLocation, Route, Outlet } from 'react-router-dom';

import JobList from '../pages/ManageJobs';
// import EmployeeDetails from '../employeeDetail/index';
import { EmployeeProvider } from '../context';

function EmployeeRouter() {
  let { pathname } = useLocation();
  console.log(pathname,"HEREEEEEEE")

  return (
    <EmployeeProvider>
    <Routes>
       <Route path="/" element={<Outlet />}>
        <Route index element={<JobList />} /> 
        {/* <Route path=":id" element={<EmployeeDetails />} />  */}

      </Route>
    </Routes>
    </EmployeeProvider>
  );
}

export default EmployeeRouter;
